<template>
  <section class="overflow-hidden" data-component="v home">
    <div class="w-full">
      <!-- Altersabfrage -->
      <div
        v-if="!ageVerification"
        class="fixed ageOverlay"
      >
        <img
          src="../../assets/images/backgrounds/gin8-home-background.jpg"
          class="absolute inline-block w-full h-screen"
        >
        <div class="flex flex-col ageOverlay-wrap">
          <div class="relative mb-16 font-bold text-center text-gin8-gold text-32px md:text-64px ageHeadline">
            Willkommen bei GIN 8
          </div>
          <div class="relative mb-12 text-center text-white text-bold text-22px md:text-32px ageQuestion">
            SIND SIE ÜBER 18 JAHRE ALT?
          </div>
          <div class="flex flex-row justify-center">
            <button
              class="z-10 w-56 px-8 py-2 mx-4 font-bold rounded-full bg-gin8-green text-gin8-gold ageOverlayDecline"
            >
              Nein
            </button>
            <button
              class="z-10 w-56 px-8 py-2 mx-4 font-bold rounded-full bg-gin8-gold text-gin8-green ageOverlayAccept"
              @click="overlayClose"
            >
              Ja
            </button>
          </div>
        </div>
      </div>
      <!-- Cookiehinweis -->
      <div
        v-if="!cookieAccepted"
        class="fixed bottom-0 z-10 flex flex-col w-screen text-white cookieNotice bg-gin8-gold md:flex-row md:grid md:grid-cols-10"
      >
        <p class="col-span-6">
          Diese Website verwendet Cookies, um sie  bestmöglich an Ihre Bedürfnisse anzupassen. Nähere Informationen dazu finden Sie in unserer <a class="underline cursor-pointer" @click="togglePrivacy">Datenschutzerklärung</a> am Ende der Seite. Wenn Sie auf der Seite weitersurfen, stimmen Sie der Cookie-Nutzung zu.
        </p>
        <button
          class="z-10 w-56 col-span-2 col-start-8 px-8 py-2 mx-4 mt-4 font-bold uppercase rounded-full cookieAccept bg-gin8-green lg:mt-0 md:mt-1/4 h-48px lg:col-start-9"
          @click="cookieAccept"
        >
          {{ Content[0].cookieHinweis.buttonLabel }}
        </button>
      </div>
      <!-- Home -->
      <div id="home" :style="cssVars" class="w-full h-screen mx-auto">
        <div class="">
          <img
            src="../../assets/images/backgrounds/gin8-home-background.jpg"
            class="absolute inline-block w-full h-screen"
          >
          <div class="flex items-center justify-center object-center h-screen pt-20 mx-auto">
            <img
              src="../../assets/images/gin8-packshot.png"
              class="absolute inline-block home-bottle full-opaque w-2xl top-5rem md:top-8rem lg:top-unset md-h-unset h-2/3"
            >
            <h1
              class="absolute block font-bold leading-tight tracking-widest text-center uppercase home-span full-opaque lg:relative bottom-6vh lg:bottom-unset text-32px lg:text-left lg:ml-770px lg:ml-head lg:text-4xl text-gin8-gold"
              v-html="Content[0].home.headlineCopy"
            />
            <a
              v-scroll-to="Navitems[0].url"
              class="arrow"
              href="#unsere-heimat"
            />
          </div>
        </div>
      </div>
      <!-- Unsere Heimat -->
      <div id="unsere-heimat" class="">
        <div class="object-center max-w-3xl px-8 mx-auto lg:py-64 pt-80px lg:px-0">
          <img :src="hopfendolde" class="mx-auto text-opacity-025 max-w-65px lg:max-w-unset " style="opacity:0.3">
          <h2 class="font-bold tracking-widest text-center uppercase text-32px lg:text-6xl text-gin8-gold">
            {{ Content[0].unsereHeimat.headlineCopy }}
          </h2>
          <div
            class="pt-8 tracking-wider text-center text-white text-18px lg:text-22px"
            v-html="Content[0].unsereHeimat.copy"
          />
        </div>
      </div>
      <!-- Unsere Zutaten -->
      <div id="unsere-zutaten" class="pre-transition">
        <div class="object-center px-8 pt-32 mx-auto max-w-770px lg:px-0">
          <h2 class="font-bold leading-none tracking-wide text-center uppercase md:tracking-widest text-32px lg:text-6xl text-gin8-gold">
            {{ Content[0].unsereZutaten.headlineCopy }}
          </h2>
          <div class="pt-8 tracking-wider text-center text-white text-18px lg:text-22px">
            {{ Content[0].unsereZutaten.copy }}
          </div>
          <div
            class="flex justify-center object-center pt-12 font-bold tracking-wider zutaten-image-wrap lg:min-h-65vh lg:pb-48 text-22px text-gin8-gold"
          >
            <img
              src="../../assets/images/gin8-packshot-back.png"
              class="relative inline-block mb-32 lg:absolute w-2xl max-h-55-vh lg:max-h-65-vh left-neg-80px md:left-neg-130px lg:left-neg-80px lg:left-unset"
            >
            <div class="relative flex-col hidden w-1/2 mt-56 text-right left-ingredients right-1/3 lg:flex">
              <span class="full-opaque" v-html="Content[0].unsereZutaten.bulletpoints[0]" />
              <span class="pt-16 full-opaque" v-html="Content[0].unsereZutaten.bulletpoints[1]" />
              <span class="pt-24 full-opaque" v-html="Content[0].unsereZutaten.bulletpoints[2]" />
            </div>
            <div class="relative flex-col hidden w-1/2 mt-56 lg:flex right-ingredients left-1/3">
              <span class="full-opaque" v-html="Content[0].unsereZutaten.bulletpoints[3]" />
              <span class="pt-24 full-opaque" v-html="Content[0].unsereZutaten.bulletpoints[4]" />
              <span class="pt-24 full-opaque" v-html="Content[0].unsereZutaten.bulletpoints[5]" />
            </div>
            <div class="absolute right-0 flex flex-col w-2/5 full-ingredients lg:hidden md:pt-4 text-18px">
              <span
                v-for="(bulletpoint, i) in Content[0].unsereZutaten.bulletpoints"
                :key="i"
                class="pb-8 md:pb-10 full-opaque"
                v-html="bulletpoint"
              />
            </div>
          </div>
        </div>
      </div>
      <!-- Unsere Verfahren -->
      <div
        id="unser-verfahren"
        class="relative block px-8 pt-16 pb-32 overflow-visible w-100 lg:px-0 xl:min-h-unset -mt-4rem md:mt-unset md:pt-16 lg:pt-32"
      >
        <img
          ref="sidebottle"
          src="../../assets/images/gin8-packshot-back.png"
          class="absolute inline-block sidebottle mt-10rem md:mt-17rem right-neg-190px lg:right-neg-200px xl:right-neg-200px md:right-neg-164px"
        >
        <div class="object-center mx-auto max-w-770px">
          <div class="testimonial-wrap lg:min-h-22rem min-h-30rem md:min-h-15rem">
            <div
              v-for="(item, i) in Content[0].unserVerfahren.quotes"
              :key="i"
              class="hidden text-white text-35px lg:text-5xl leading-45px lg:leading-tight testimonial"
            >
              <div
                class=""
                v-html="item.quote"
              />
              <div
                v-waypoint="{ active: true, callback: greenBackground, options: intersectionOptions }"
                class="pt-6 leading-tight text-left text-white text-20px lg:text-2xl lg:text-right text-gin8-gold md:pr-16 lg:pr-0"
              >
                {{ item.testimonial }}
              </div>
            </div>
          </div>
          <h2
            class="max-w-xl font-bold leading-none text-left uppercase text-32px lg:text-6xl text-gin8-gold lg:mt-13rem"
          >
            {{ Content[0].unserVerfahren.headlineCopy }}
          </h2>
          <div
            v-waypoint="{ active: true, callback: greenBackground, options: intersectionOptions }"
            class="flex mb-0 lg:mb-16rem"
          >
            <ul class="max-w-xl pt-8 pr-24 list-disc lg:max-2-2xl lg:pr-0 text-18px lg:text-22px ml-23px">
              <li
                v-for="bulletpoint in Content[0].unserVerfahren.bulletpoints"
                :key="bulletpoint"
                class="pt-4 text-white"
              >
                {{ bulletpoint }}
              </li>
            </ul>
          </div>
        </div>
      </div>
      <!-- Unsere Empfehlung -->
      <div
        id="unsere-empfehlung"
        class="relative block overflow-hidden w-100"
      >
        <div class="invisible object-center px-8 pt-24 mx-auto max-w-770px lg:px-0 transition-area-white">
          <h2
            class="font-bold tracking-wide text-left uppercase text-35px lg:text-6xl leading-30px lg:leading-unset text-gin8-gold "
          >
            {{ Content[0].unsereEmpfehlung.headlineCopy }}
          </h2>
          <div
            v-waypoint="{ active: true, callback: whiteBackground, options: intersectionOptions }"
            class="pt-8 pr-40 tracking-wide text-left text-black lg:pr-0 text-18px lg:text-22px "
            v-html="Content[0].unsereEmpfehlung.copy"
          />
          <h3 class="pt-20 font-bold tracking-wide text-left uppercase text-32px lg:text-50px text-gin8-gold">
            {{ Content[0].unsereEmpfehlung.cocktailHeadline }}
          </h3>
          <div class="flex flex-col pt-8 font-bold lg:flex-row w-56rem text-20px lg:text-31px tracking-none">
            <div class="relative block w-1/3">
              <h4 class="text-gin8-gold ">
                {{ Content[0].unsereEmpfehlung.cocktailIngredientsHeadline }}
              </h4>
              <ul class="pt-4 font-normal text-black text-18px lg:text-22px">
                <li
                  v-for="ingredient in Content[0].unsereEmpfehlung.cocktailIngredientsBullets"
                  :key="ingredient"
                  class="pb-2 tracking-normal"
                >
                  {{ ingredient }}
                </li>
              </ul>
            </div>
            <div class="relative block w-3/5 pt-8 pl-0 lg:pt-0">
              <h4 class="text-gin8-gold ">
                {{ Content[0].unsereEmpfehlung.coktailHowtoHeadline }}
              </h4>
              <ul
                v-waypoint="{ active: true, callback: whiteBackground, options: intersectionOptions }"
                class="w-screen pt-4 pr-56 font-normal text-black text-18px lg:text-22px lg:pr-0 lg:w-unset"
              >
                <li
                  v-for="howto in Content[0].unsereEmpfehlung.cocktailHowtoBullets"
                  :key="howto"
                  class="inline-block pb-2 tracking-normal"
                  v-html="howto"
                />
              </ul>
            </div>
          </div>
        </div>
      </div>
      <!-- Unser Kontakt -->
      <div
        id="kontakt"
        class=""
      >
        <div
          class="invisible object-center px-8 pt-24 pb-12 mx-auto transition-area-green max-w-770px lg:px-0 lg:py-64"
        >
          <h2
            v-waypoint="{ active: true, callback: greenBackground, options: intersectionOptions }"
            class="mr-24 font-bold leading-none tracking-wide text-left uppercase md:tracking-widest lg:text-center text-32px lg:text-6xl text-gin8-gold md:mr-0"
          >
            {{ Content[0].kontakt.headlineCopy }}
          </h2>
          <div
            class="pt-8 pb-16 mr-24 tracking-wider text-left text-white md:mr-48 lg:mr-0 lg:text-center text-18px lg:text-22px lg:pb-0"
            v-html="Content[0].kontakt.copy"
          />
          <div class="pt-40 font-bold text-left text-white md:text-center md:text-22px text-20px">
            {{ Content[0].kontakt.warning }}
          </div>
          <div class="flex justify-around w-3/4 pt-4 mx-auto text-gin8-gold center md:w-1/3 lg:pt-12">
            <a class="inline-block cursor-pointer hover:underline center" @click="toggleImprint">Impressum</a>
            <a class="inline-block cursor-pointer hover:underline" @click="togglePrivacy">Datenschutz</a>
          </div>
          <div class="flex justify-around w-3/4 pt-8 mx-auto text-gin8-gold center md:w-1/4">
            <a class="icon facebook" :href="Content[0].kontakt.facebook" />
            <a class="icon insta" :href="Content[0].kontakt.insta" />
          </div>
        </div>
      </div>
      <!-- Impressum -->
      <div id="impressum">
        <div v-if="imprint" class="fixed overflow-y-scroll imprint text-gin8-gold">
          <svg
            class="inline-block w-32 h-16 fill-current lg:w-40 lg:h-20 overlayLogo"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 100 70"
          >
            <path
              id="GIN8"
              d="M27.5549032,35.1540741 C27.5549032,39.9988889 26.8076516,42.8211111 24.3790839,45.3611111 C21.6235935,48.2774074 18.5411806,49.1711111 14.9917355,49.1711111 C11.2087742,49.1711111 8.40658065,47.9011111 6.11812258,45.6433333 C2.80219355,42.3037037 2.75549032,38.5407407 2.75549032,32.1437037 C2.75549032,25.7466667 2.80219355,21.9837037 6.11812258,18.6440741 C8.40658065,16.3862963 11.2087742,15.1162963 14.9917355,15.1162963 C22.744471,15.1162963 26.6208387,20.1962963 27.5082,25.8407407 L20.9697484,25.8407407 C20.2224968,22.6422222 18.3076645,20.9488889 14.9917355,20.9488889 C13.2170129,20.9488889 11.8159161,21.6544444 10.8351484,22.7362963 C9.62086452,24.1474074 9.24723871,25.7466667 9.24723871,32.1437037 C9.24723871,38.5407407 9.62086452,40.187037 10.8351484,41.5981481 C11.8159161,42.68 13.2170129,43.3385185 14.9917355,43.3385185 C16.9999742,43.3385185 18.5878839,42.632963 19.6153548,41.457037 C20.689529,40.2340741 21.1098581,38.7288889 21.1098581,36.9885185 L21.1098581,35.7655556 L14.9917355,35.7655556 L14.9917355,30.2622222 L27.5549032,30.2622222 L27.5549032,35.1540741 Z M40.6785097,48.8888889 L34.1867613,48.8888889 L34.1867613,15.3985185 L40.6785097,15.3985185 L40.6785097,48.8888889 Z M73.8845032,48.8888889 L68.0933032,48.8888889 L54.9229935,28.3337037 L54.9229935,48.8888889 L48.4312452,48.8888889 L48.4312452,15.3985185 L54.2224452,15.3985185 L67.3927548,35.9066667 L67.3927548,15.3985185 L73.8845032,15.3985185 L73.8845032,48.8888889 Z M111.947632,39.1522222 C111.947632,45.6433333 107.183903,49.1711111 101.299297,49.1711111 C95.4146903,49.1711111 90.6509613,45.6433333 90.6509613,39.1522222 C90.6509613,35.06 92.9861226,32.8492593 94.8075484,31.6262963 C93.1262323,30.4503704 91.0712903,28.2396296 91.0712903,24.6648148 C91.0712903,18.7381481 95.7416129,15.1162963 101.299297,15.1162963 C106.856981,15.1162963 111.4806,18.7381481 111.4806,24.6648148 C111.4806,28.2396296 109.425658,30.4503704 107.744342,31.6262963 C109.565768,32.8492593 111.947632,35.06 111.947632,39.1522222 Z M105.876213,39.0581481 C105.876213,36.4711111 103.867974,34.4014815 101.299297,34.4014815 C98.7306194,34.4014815 96.7223806,36.4711111 96.7223806,39.0581481 C96.7223806,41.6451852 98.7306194,43.6677778 101.299297,43.6677778 C103.867974,43.6677778 105.876213,41.6451852 105.876213,39.0581481 Z M105.409181,24.852963 C105.409181,22.4540741 103.681161,20.6196296 101.299297,20.6196296 C98.9174323,20.6196296 97.1427097,22.4540741 97.1427097,24.852963 C97.1427097,27.2988889 98.9174323,29.0862963 101.299297,29.0862963 C103.681161,29.0862963 105.409181,27.2988889 105.409181,24.852963 Z"
            />
          </svg>
          <div class="absolute text-gin8-gold text-32px close-button top-1rem lg:top-2rem right-2rem lg:top-6rem" @click="toggleImprint" />
          <div class="object-center max-w-3xl mx-20px lg:mx-auto">
            <div class="mb-10 font-bold text-left uppercase text-32px lg:text-64px text-gin8-gold">{{ Content[0].impressum.headline }}</div>
            <p
              v-for="(line, index) in Content[0].impressum.address"
              :key="index"
              class="text-white text-22px"
              v-html="line"
            />
          </div>
        </div>
      </div>
      <!-- Datenschutz -->
      <div id="datenschutz">
        <div v-if="privacy" class="fixed overflow-y-scroll imprint text-gin8-gold">
          <svg
            class="inline-block w-32 h-16 fill-current lg:w-40 lg:h-20 overlayLogo"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 100 70"
          >
            <path
              id="GIN8"
              d="M27.5549032,35.1540741 C27.5549032,39.9988889 26.8076516,42.8211111 24.3790839,45.3611111 C21.6235935,48.2774074 18.5411806,49.1711111 14.9917355,49.1711111 C11.2087742,49.1711111 8.40658065,47.9011111 6.11812258,45.6433333 C2.80219355,42.3037037 2.75549032,38.5407407 2.75549032,32.1437037 C2.75549032,25.7466667 2.80219355,21.9837037 6.11812258,18.6440741 C8.40658065,16.3862963 11.2087742,15.1162963 14.9917355,15.1162963 C22.744471,15.1162963 26.6208387,20.1962963 27.5082,25.8407407 L20.9697484,25.8407407 C20.2224968,22.6422222 18.3076645,20.9488889 14.9917355,20.9488889 C13.2170129,20.9488889 11.8159161,21.6544444 10.8351484,22.7362963 C9.62086452,24.1474074 9.24723871,25.7466667 9.24723871,32.1437037 C9.24723871,38.5407407 9.62086452,40.187037 10.8351484,41.5981481 C11.8159161,42.68 13.2170129,43.3385185 14.9917355,43.3385185 C16.9999742,43.3385185 18.5878839,42.632963 19.6153548,41.457037 C20.689529,40.2340741 21.1098581,38.7288889 21.1098581,36.9885185 L21.1098581,35.7655556 L14.9917355,35.7655556 L14.9917355,30.2622222 L27.5549032,30.2622222 L27.5549032,35.1540741 Z M40.6785097,48.8888889 L34.1867613,48.8888889 L34.1867613,15.3985185 L40.6785097,15.3985185 L40.6785097,48.8888889 Z M73.8845032,48.8888889 L68.0933032,48.8888889 L54.9229935,28.3337037 L54.9229935,48.8888889 L48.4312452,48.8888889 L48.4312452,15.3985185 L54.2224452,15.3985185 L67.3927548,35.9066667 L67.3927548,15.3985185 L73.8845032,15.3985185 L73.8845032,48.8888889 Z M111.947632,39.1522222 C111.947632,45.6433333 107.183903,49.1711111 101.299297,49.1711111 C95.4146903,49.1711111 90.6509613,45.6433333 90.6509613,39.1522222 C90.6509613,35.06 92.9861226,32.8492593 94.8075484,31.6262963 C93.1262323,30.4503704 91.0712903,28.2396296 91.0712903,24.6648148 C91.0712903,18.7381481 95.7416129,15.1162963 101.299297,15.1162963 C106.856981,15.1162963 111.4806,18.7381481 111.4806,24.6648148 C111.4806,28.2396296 109.425658,30.4503704 107.744342,31.6262963 C109.565768,32.8492593 111.947632,35.06 111.947632,39.1522222 Z M105.876213,39.0581481 C105.876213,36.4711111 103.867974,34.4014815 101.299297,34.4014815 C98.7306194,34.4014815 96.7223806,36.4711111 96.7223806,39.0581481 C96.7223806,41.6451852 98.7306194,43.6677778 101.299297,43.6677778 C103.867974,43.6677778 105.876213,41.6451852 105.876213,39.0581481 Z M105.409181,24.852963 C105.409181,22.4540741 103.681161,20.6196296 101.299297,20.6196296 C98.9174323,20.6196296 97.1427097,22.4540741 97.1427097,24.852963 C97.1427097,27.2988889 98.9174323,29.0862963 101.299297,29.0862963 C103.681161,29.0862963 105.409181,27.2988889 105.409181,24.852963 Z"
            />
          </svg>
          <div class="absolute text-gin8-gold text-32px close-button top-1rem lg:top-2rem right-2rem lg:top-6rem" @click="togglePrivacy" />
          <div class="object-center max-w-3xl mx-20px lg:mx-auto">
            <div class="mb-10 font-bold text-left uppercase text-22px md:text-32px lg:text-64px text-gin8-gold">{{ Content[0].datenschutz.headline }}</div>
            <p
              v-for="(line, index) in Content[0].datenschutz.text"
              :key="index"
              class="text-white text-22px"
              v-html="line"
            />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Content from '../../config/content';
import Navitems from '../../config/mainNavItems';
import Hopfendolde from '../../assets/images/svg/Hopfendolde.svg';

export default {
  name: 'VHome',
  components: {},
  data() {
    return {
      intersectionOptions: {
        root: null,
        rootMargin: '0px 0px 0px 0px',
        threshold: [0, 1], // [0.25, 0.75] if you want a 25% offset!
      },
      navigationIntersectionOptions: {
        root: null,
        rootMargin: '0px 0px 0px 0px',
        threshold: [0, 1], // [0.25, 0.75] if you want a 25% offset!
      },
      Navitems,
      Content,
      hopfendolde: Hopfendolde,
      sideBottlePositionInitial: 0,
      sideBottleFlag: false,
      ageVerification: false,
      cookieAccepted: false,
      imprint: false,
      privacy: false,
      device: '',
    };
  },
  computed: {
    cssVars() {
      return {
        '--bg-image': Content[0].home.background,
        '--bg-image-back': Content[0].unserVerfahren.background,
        '--gin8-gold': Content[0].colours.gold,
        '--gin8-green': Content[0].colours.green,
      };
    },
  },
  mounted() {
    const background = document.querySelector('div[data-component="v layout"]');
    background.classList.add('bg-gin8-green');
    if (localStorage.getItem('gin8-age')) {
      this.ageVerification = true;
    } else {
      window.addEventListener('scroll', this.noScroll);
      document.querySelector('.cookieNotice').classList.add('invisible');
    }
    if (localStorage.getItem('gin8-cookie')) {
      this.cookieAccepted = true;
    }
    const sideBottle = this.$refs.sidebottle;
    const sideBottlePosition = sideBottle.getBoundingClientRect();
    this.sideBottlePositionInitial = this.getElemDistance(this.$refs.sidebottle);
    // device detection
    let exitCondition = 0;
    if (window.innerWidth >= 1025) {
      exitCondition = window.pageYOffset;
      this.device = 'desktop';
      this.intersectionOptions = {
        root: null,
        rootMargin: '0px 0px -200px 0px',
        threshold: 0.4, // [0.25, 0.75] if you want a 25% offset!
      };
    } else if (window.innerWidth >= 768) {
      this.device = 'tablet';
      exitCondition = window.pageYOffset;
      this.intersectionOptions = {
        root: null,
        rootMargin: '0px 0px -200px 0px',
        threshold: 0.5, // [0.25, 0.75] if you want a 25% offset!
      };
    } else {
      this.device = 'mobile';
      exitCondition = window.pageYOffset;
      this.intersectionOptions = {
        root: null,
        rootMargin: '0px 0px 0px 0px',
        threshold: 0.3, // [0.25, 0.75] if you want a 25% offset!
      };
    }
    this.quoteSwitch();
    // Fading in the elements on home
    if (this.ageVerification) {
      this.homeFadeIn();
    }
    const mainNavLinks = document.querySelectorAll('.navitem');
    const sideBottleStyle = window.getComputedStyle(sideBottle);
    this.sideBottlePositionInitial += parseInt(sideBottleStyle.marginTop.substring(0, sideBottleStyle.marginTop.length - 2), 10);
    window.addEventListener('scroll', () => {
      this.ingredientFadeIn();
      this.sideBottleScroll();
      if (this.device === 'desktop') {
        this.activeNavigation(mainNavLinks);
      }
    });
  },
  methods: {
    noScroll() {
      window.scrollTo(0, 1);
    },
    togglePrivacy() {
      this.privacy = !this.privacy;
    },
    toggleImprint() {
      this.imprint = !this.imprint;
    },
    cookieAccept() {
      this.cookieAccepted = true;
      localStorage.setItem('gin8-cookie', 'true');
    },
    overlayClose() {
      this.ageVerification = true;
      window.removeEventListener('scroll', this.noScroll);
      localStorage.setItem('gin8-age', 'true');
      this.homeFadeIn();
      if (this.cookieAccepted === false) {
        document.querySelector('.cookieNotice').classList.remove('invisible');
      }
    },
    homeFadeIn() {
      document.querySelector('.home-bottle').classList.remove('full-opaque');
      document.querySelector('.home-bottle').classList.add('fade-in-opacity');
      setTimeout(() => {
        document.querySelector('.home-span').classList.remove('full-opaque');
        document.querySelector('.home-span').classList.add('fade-in-opacity');
      }, 750);
    },
    quoteSwitch() {
      let flag = 42;
      const quoteCount = this.Content[0].unserVerfahren.quotes.length;
      const randomSelection = this.getRandomInt(this.Content[0].unserVerfahren.quotes.length);
      const elements = document.querySelectorAll('.testimonial');
      for (let i = 0; i < quoteCount; i += 1) {
        if (i === randomSelection) {
          elements[i].classList.remove('hidden');
          elements[i].classList.remove('full-opaque');
          elements[i].classList.add('fade-in-opacity');
          flag = i;
          setTimeout(() => {
            elements[i].classList.remove('fade-in-opacity');
            elements[i].classList.add('fade-out-opacity');
          }, 8000);
        } else {
          elements[i].classList.add('full-opaque');
          elements[i].classList.add('hidden');
        }
      }
      setInterval(() => {
        const quoteCount = this.Content[0].unserVerfahren.quotes.length;
        let randomSelection = this.getRandomInt(this.Content[0].unserVerfahren.quotes.length);
        for (randomSelection; randomSelection === flag; randomSelection = this.getRandomInt(this.Content[0].unserVerfahren.quotes.length)) {
          const foo = 'bar';
        }
        const elements = document.querySelectorAll('.testimonial');
        for (let i = 0; i < quoteCount; i += 1) {
          if (i === randomSelection) {
            elements[i].classList.remove('hidden');
            elements[i].classList.remove('full-opaque');
            elements[i].classList.add('fade-in-opacity');
            flag = i;
            setTimeout(() => {
              elements[i].classList.remove('fade-in-opacity');
              elements[i].classList.add('fade-out-opacity');
            }, 8000);
          } else {
            elements[i].classList.add('full-opaque');
            elements[i].classList.add('hidden');
          }
        }
      }, 10000);
    },
    getRandomInt(max) {
      return Math.floor(Math.random() * Math.floor(max));
    },
    ingredientFadeIn() {
      const zutatenDiv = document.querySelector('#unsere-zutaten');
      const zutatenPosition = zutatenDiv.getBoundingClientRect();
      const fromLeft = document.querySelector('.left-ingredients');
      const fromRight = document.querySelector('.right-ingredients');
      if (this.device === 'desktop') {
        if (zutatenPosition.top <= 100) {
          const leftChildren = fromLeft.children;
          const rightChildren = fromRight.children;
          for (let i = 0; i < leftChildren.length; i += 1) {
            setTimeout(() => {
              const tableChild = leftChildren[i];
              tableChild.classList.add('fade-in-opacity');
              tableChild.classList.remove('full-opaque');
            }, i * 1000);
          }
          for (let i = 0; i < rightChildren.length; i += 1) {
            setTimeout(() => {
              const tableChild = rightChildren[i];
              tableChild.classList.add('fade-in-opacity');
              tableChild.classList.remove('full-opaque');
            }, i * 1000 + 500);
          }
        }
      } else if (zutatenPosition.top <= 100) {
        const fullIngredients = document.querySelector('.full-ingredients').children;
        for (let i = 0; i < fullIngredients.length; i += 1) {
          setTimeout(() => {
            const tableChild = fullIngredients[i];
            tableChild.classList.add('fade-in-opacity');
            tableChild.classList.remove('full-opaque');
          }, i * 500);
        }
      }
    },
    sideBottleScroll() {
      const sideBottle = this.$refs.sidebottle;
      const sideBottlePosition = sideBottle.getBoundingClientRect();
      const bottleSpaceToTop = (window.innerHeight - sideBottlePosition.height) / 2;
      let offset = 0;
      let offset2 = 0;
      if (this.device === 'desktop') {
        offset = -(window.innerHeight - sideBottlePosition.height);
      } else if (this.device === 'tablet') {
        offset = 230;
        offset2 = 230;
      } else if (this.device === 'mobile') {
        offset = 1100;
        offset2 = 1100;
      } else {
        offset = 0;
      }
      if (window.pageYOffset >= this.sideBottlePositionInitial + offset) {
        sideBottle.classList.remove('absolute');
        sideBottle.classList.remove('mt-44rem');
        sideBottle.classList.remove('md:mt-17rem');
        sideBottle.classList.add('fixed');
        sideBottle.style.top = ((window.innerHeight - sideBottlePosition.height) / 2).toString().concat('px');
      } else if (window.pageYOffset <= this.sideBottlePositionInitial + offset2) {
        sideBottle.style.top = '0px';
        sideBottle.classList.add('absolute');
        sideBottle.classList.add('md:mt-17rem');
        sideBottle.classList.add('mt-44rem');
        sideBottle.classList.remove('fixed');
        sideBottle.classList.remove('top-1/5');
      }
    },
    activeNavigation(mainNavLinks) {
      const fromTop = window.scrollY;
      mainNavLinks.forEach((link) => {
        const selector = `#${link.id}`;
        const section = document.querySelector(selector.slice(0, -4));
        if (
          section.offsetTop <= fromTop
          && section.offsetTop + section.offsetHeight > fromTop
        ) {
          link.classList.add('active');
        } else {
          link.classList.remove('active');
        }
      });
    },
    whiteBackground({ going, direction }) {
      if (going === this.$waypointMap.GOING_IN) {
        // Background div to change colors
        const background = document.querySelector('div[data-component="v layout"]');
        // White Section
        const whiteDiv = document.querySelector('#unsere-empfehlung');
        // Background div of navigation
        const navBackground = document.querySelector('.nav-container');
        // Position of white Section
        const screenPosition = whiteDiv.getBoundingClientRect();
        background.classList.remove('bg-gin8-green');
        navBackground.classList.remove('bg-gin8-green');
        // Navi bekommt weißen Hintergrund
        navBackground.classList.add('bg-white');
        // Elemente der white Section werden sichtbar
        document.querySelector('.transition-area-white').classList.remove('invisible');
        // Elemente der green section werden unsichtbar
        document.querySelector('.transition-area-green').classList.add('invisible');
      }
    },
    greenBackground({ going, direction }) {
      const background = document.querySelector('div[data-component="v layout"]');
      const navBackground = document.querySelector('.nav-container');
      if (going === this.$waypointMap.GOING_IN) {
        background.classList.add('bg-gin8-green');
        // remove white background of navigation
        navBackground.classList.remove('bg-white');
        navBackground.classList.add('bg-gin8-green');
        // Elemente der white Section werden sichtbar
        document.querySelector('.transition-area-white').classList.add('invisible');
        // Elemente der green section werden unsichtbar
        document.querySelector('.transition-area-green').classList.remove('invisible');
      }
    },

    getElemDistance(elem) {
      let location = 0;
      if (elem.offsetParent) {
        do {
          location += elem.offsetTop;
          elem = elem.offsetParent;
        } while (elem);
      }
      return location >= 0 ? location : 0;
    },
  },
};
</script>
<style>

div[data-component="v layout"], .nav-container {
  transition: background-color 0.5s ease-in-out;
}

.transition-area-white, .transition-area-green {
  transition: visibility 0.5s ease;
}

.list-decimal li::before {
  color: #C0B47C;
}

.arrow {
  width: 3vmin;
  height: 3vmin;
  box-sizing: border-box;
  position: absolute;
  left: 50%;
  bottom: 3%;
  transform: scale(1) rotate(135deg);
  box-shadow: 0 0 0 0 rgba(0, 0, 0, 1);
  animation: pulse 2s infinite;
}

.arrow::before {
  content: '';
  width: 100%;
  height: 100%;
  border-width: .8vmin .8vmin 0 0;
  border-style: solid;
  border-color: var(--gin8-gold);
  transition: .2s ease;
  display: block;
  transform-origin: 100% 0;
}


.arrow:after {
  content: '';
  float: left;
  position: relative;
  top: -100%;
  width: 100%;
  height: 100%;
  border-width: 0 .8vmin 0 0;
  border-style: solid;
  border-color: var(--gin8-gold);
  transform-origin: 100% 0;
  transition: .2s ease;
}

.testimonial-wrap{
  min-height: 20rem;
}

.icon.facebook:before {
  content: url('../../assets/images/svg/facebook.svg');
}

.icon.insta:before {
  content: url('../../assets/images/svg/instagram.svg');
}

.icon.youtube:before {
  content: url('../../assets/images/svg/youtube.svg');
}

.full-opaque {
  opacity: 0;
}

button:active, button:focus, button:hover {
  outline: none;
}

.ageOverlay, .imprint {
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  height: 100vh;
  z-index: 20;
  background-color: #00514C;
}

.ageOverlay-wrap {
  margin: 30vh auto;
  max-width: 60vw;
}

.ageOverlayDecline {
  border-color: #C0B47C;
  border-width: 2px;
  border-style: solid;
}

.ageOverlayDecline:hover {
  border-color: #b89757;
  color: #b89757;
}

.cookieAccept:hover {
  background-color: #003632;
}

.overlayLogo{
  padding-left: 1rem;
}

.ageOverlayAccept:hover {
  background-color: #b89757;
}

.cookieNotice {
  padding: 1.5rem 3rem;
}

.sidebottle {
  height: 70vh;
  width: auto;
}

.close-button:hover, .close-button:active, .close-button:focus {
  cursor: pointer;
}

.close-button {
  position: absolute;
  width: 25px;
  height: 25px;
  opacity: 1;
}
.close-button:hover {
  opacity: 1;
}
.close-button:before, .close-button:after {
  position: absolute;
  left: 15px;
  content: ' ';
  height: 26px;
  width: 2px;
  background-color: #C0B47C;
}
.close-button:before {
  transform: rotate(45deg);
}
.close-button:after {
  transform: rotate(-45deg);
}

.zutaten-image-wrap{
  height: --webkit-fill-available;
}

.fade-in-opacity {
  animation-name: fadeInOpacity;
  animation-iteration-count: 1;
  animation-timing-function: linear;
  animation-duration: 2s;
}

.fade-out-opacity {
  animation-name: fadeOutOpacity;
  animation-iteration-count: 1;
  animation-timing-function: linear;
  animation-duration: 2s;
}

@keyframes pulse {
  0% {
    transform: scale(0.8) rotate(135deg);
    box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.7);
  }

  70% {
    transform: scale(1.2) rotate(135deg);
    box-shadow: 0 0 0 10px rgba(0, 0, 0, 0);
  }

  100% {
    transform: scale(0.8) rotate(135deg);
    box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
  }
}

@keyframes fadeInOpacity {
  0% {
    opacity: 0;
  }
  25% {
    opacity: 0.1;
  }
  100% {
    opacity: 1;
  }
}

@keyframes fadeOutOpacity {
  0% {
    opacity: 1;
  }
  75% {
    opacity: 0.1;
  }
  100% {
    opacity: 0;
  }
}

</style>
